<template>
  <span :class="style.heading">Внешняя ссылка</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="widget"
      description="URL"
      v-model="localIntegration.link"
      readOnly
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import style from "./settingIntegrations.module.scss";
import {externalLinkIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationExternalLink",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integrationIndex: {
      type: Number,
      default: 0
    },
    integration: {
      type: Object as PropType<externalLinkIntegration>,
      default: () => ({})
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        link: this.integration.link ?? ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.externalLink;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          link: newVal.link || ""
        };
      }
    }
  }
});
</script>
